import PropTypes from 'prop-types';
import React from 'react';

import {
  StyledSection,
  IntroSectionContent,
  IntroBgVideo,
  PlayButton,
  YouTubeModal,
  YouTubeWrapper,
  YouTubeInner,
  ScrollWrapper,
  ScrollText,
  ScrollButton,
} from './IntroSection.styled';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';

import Modal from '@components/Shared/Modal/Modal';

class Intro extends React.Component {
  constructor() {
    super();

    this.state = {
      modalOpen: false,
    };

    this.closeModal = this.closeModal.bind(this);
    this.openModal = this.openModal.bind(this);
    this.scrollDown = this.scrollDown.bind(this);
  }

  openModal() {
    pushGTMEvent('ch.cta_click', 'dtr_header_play', {
      location: 'Dream to Reality',
      category: 'brand_education',
      action: 'video',
      label: 'dtr_header_play',
    });

    this.setState({ modalOpen: true });
  }

  closeModal() {
    this.setState({ modalOpen: false });
  }

  scrollDown() {
    if (typeof window !== 'undefined') {
      const top = window.innerHeight - 76;
      window.scroll({ top, behavior: 'smooth' });
    }
  }

  componentDidMount() {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      const vh = window.innerHeight * 0.01;
      document.getElementById('dtr-intro').style.setProperty('--vh', `${vh}px`);
    }
  }

  render() {
    return (
      <StyledSection id="dtr-intro" smallScreen={this.props.smallScreen}>
        <IntroSectionContent>
          <h3 className="h1">{this.props.header}</h3>
          <p className="standard">{this.props.blurb}</p>
        </IntroSectionContent>

        <PlayButton
          onClick={this.openModal}
          title="Video of home buying experience"
        />

        {this.state.modalOpen && (
          <YouTubeModal>
            <Modal onClose={this.closeModal}>
              <YouTubeWrapper>
                <YouTubeInner>
                  <iframe
                    title="Video of home buying experience"
                    width="1499"
                    height="729"
                    src="https://www.youtube.com/embed/-mj-IcJYpt8?rel=0"
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </YouTubeInner>
              </YouTubeWrapper>
            </Modal>
          </YouTubeModal>
        )}

        <IntroBgVideo
          id="video-intro"
          dangerouslySetInnerHTML={{
            __html: `
               <video
                  src="https://www.claytonhomes.com/videos/dreamtoreality/dream/This-Isn-t-a-Dream_cr_03_Conform2_1.mp4"
                  poster="/public-assets/images/dream-to-reality/poster_this-isnt-a-dream.jpg"
                  autoplay
                  muted
                  loop
                  playsinline
               />
            `,
          }}
        />

        <ScrollWrapper className="scroll" onClick={this.scrollDown}>
          <ScrollText>SCROLL</ScrollText>
          <ScrollButton />
        </ScrollWrapper>
      </StyledSection>
    );
  }
}

Intro.propTypes = {
  blurb: PropTypes.any,
  header: PropTypes.any,
  smallScreen: PropTypes.any,
};

export default Intro;
